import styled from "@emotion/styled"
import { FlexContainer } from "../../../styled/flexbox.styled"
import { SCIENT_COLORS } from "../../../styled/scientColors"

export const CollapseContainer = styled(FlexContainer)`
  padding: 10px;
  border-radius: 3px;
  margin-bottom: 10px;
`

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const CountBadge = styled.span`
  margin-left: 8px;
  font-size: 12px;
  color: ${SCIENT_COLORS.orange5};
`
